
import Vue from 'vue';
import VRuntimeTemplate from 'v-runtime-template';
export default Vue.extend({
  components: {
    VRuntimeTemplate,
  },
  props: {
    data: {
      type: String,
      required: true,
    },
  },
  computed: {
    compiledTemplate() {
      let template = this.data.replace(/a href/g, 'a rel="noopener noreferrer" href');

      // Add keys to components that will update dynamically since they lack data
      template = template.replace(/v-bind='{"uid":"([\d\w-]+)"}'/gm, `v-bind='{"key":"$1","uid":"$1"}'`);
      return template;
    },
  },
});
